const detailInitialState = {
  isLoading: false,
  isFailedInit: false,
  details: {
    additionalInfo: {
      accountNumber: null,
      auditedBy: null,
      auditedOn: null,
      dateOfService: '',
      department: '',
      dob: '',
      facility: '',
      finalizedBy: null,
      finalizedOn: null,
      gender: null,
      mrn: null,
      patientName: '',
      payer: null,
      physician: '',
      physicianSpecialty: ''
    },
    currentEncounterInfo: {
      auditedFor: null,
      contractId: 0,
      encounterId: 0,
      finalizedBy: null,
      isFinalized: true,
      isOnHold: true,
      patientId: 0
    },
    patientHistory: [],
    encounterCard: {
      encounterText: ''
    },
    encounterList: { items: [] }, // lookback
    organizationId: -1,
    reasonOptions: [],
    encounterAuditReasons:[],
    encounterHoldReasonOptions:[],
    canRemoveHold: false
  }
};

export default detailInitialState;
